import { API } from './instances'

export const getNotification = async data => {
    const url = '/Notificaciones/Get'
    return await API.get(url, { params: data })
}

export const createNotification = async ({
    targetClientId,
    notificationTypeCode,
    mobileTitle,
    payload: { message, url: payloadUrl, isInternal }
}) => {
    const url = '/Notificaciones/Push'
    return await API.post(url, {
        targetClientId,
        notificationTypeCode,
        mobileTitle,
        payload: { message, url: payloadUrl, isInternal }
    })
}
export const registerFcmToken = async token => {
    const url = '/FirebaseTokens/Registrar'
    return await API.post(url, { firebaseToken: token }, { skipErrorMessage: true })
}